import React, { useEffect, useState } from "react";
import { Get } from "../../../../utils/request";
import { useSelector } from "react-redux";
import Board from "./Card";
import SkeletonCardList from "modules/LoadingPlaceholders/Skeletons/SkeletonCardList";
import "keen-slider/keen-slider.min.css";
import { Carousel } from "react-responsive-carousel";

// mui icons
import { Box, Container, Typography } from "@mui/material";
import { STORAGE_URL } from "variables";

const DisplayCoursesPreview = ({ banners }) => {
  const [mui_theme, setMuiTheme] = useState({});
  const [listed_courses, setListedCourses] = useState([]);
  const [categories, setCategories] = useState([]);

  const userId = useSelector((store) => store.AppReducer.user.id);
  const loginTheme = useSelector(
    (store) => store.StylesReducer.pagesThemes?.mural_cursos
  );

  useEffect(() => {
    setMuiTheme(loginTheme?.palette?.data);
  }, [loginTheme]);

  const [isLoading, setLoading] = useState(true);

  const getCategories = async () => {
    await Get(`courses-main/category?userId=${userId}`).then((res) => {
      setCategories(res.categories);
      setLoading(false);
    });
  };

  useEffect(() => {
    getCategories();
  }, []);

  const getMyList = async () => {
    await Get(`user-list-course?userId=${userId}`).then((res) => {
      console.log(res);
      let temp_list = [];
      res?.list.map((course) => {
        temp_list.push(course.course_id);
      });
      setListedCourses(temp_list);
      console.log(temp_list);
    });
  };

  useEffect(() => {
    getMyList();
  }, []);

  if (isLoading)
    return (
      <Container maxWidth="xl" sx={{ padding: "0", paddingTop: "2rem" }}>
        <SkeletonCardList />
      </Container>
    );

  return (
    !isLoading && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          width: "100%",
          height: "100%",
          minWidth: 0,
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: mui_theme.background_color,
          minHeight: "100%",
          paddingTop: "2rem",
        }}
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            zIndex: 20,
          }}
        >
          {banners?.length > 0 && (
            <Carousel
              autoPlay={true}
              infiniteLoop={true}
              renderIndicator={false}
              centerMode={false}
              showThumbs={false}
              transitionTime={500}
              interval={5000}
              showStatus={false}
            >
              {banners &&
                banners.map((banner, index) => (
                  <a
                    key={banner.id}
                    href={banner.link}
                    target="_blank"
                    style={{
                      zIndex: 20,
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        aspectRatio: "3 / 1",
                        backgroundSize: "contain",
                        backgroundImage: `url(${STORAGE_URL + banner.image})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </a>
                ))}
            </Carousel>
          )}
        </div>

        {categories?.map((category, index) => {
          return (
            category?.courses?.length !== 0 && (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0.8rem",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    display: "flex",
                    gap: "0.2rem",
                    alignItems: "center",
                    fontWeight: "bold",
                    paddingLeft: "2rem",
                    color: mui_theme.font_color,
                  }}
                >
                  {category.name}
                </Typography>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(18rem, 1fr))",
                    gap: "1rem",
                    alignItems: "start",
                    paddingTop: "0.8rem",
                  }}
                >
                  {category?.courses?.map((course, index2) => {
                    if (course?.lessons?.length !== 0)
                      return (
                        <Board
                          key={index2}
                          {...course}
                          isUserIn={course?.usercourse !== null}
                          fontColor={mui_theme.font_color}
                          listed_courses={listed_courses}
                        />
                      );
                  })}
                </div>
              </div>
            )
          );
        })}
      </div>
    )
  );
};

export default DisplayCoursesPreview;
